module.exports = __webpack_public_path__ + "static/media/Icon-star-empty.b772dda6.svg";